"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isSocialMediaImageItem = exports.isSocialMediaVideoItem = exports.isInstagramAccount = exports.isFacebookPage = exports.isFabricSocialMediaOptions = exports.SocialMediaResponseFormat = exports.SocialMediaSelectionType = exports.SocialMediaWidgetOrientation = exports.SocialMediaItemType = exports.SocialMediaItemsType = exports.SocialMediaPlatform = void 0;
const objects_1 = require("./objects");
var SocialMediaPlatform;
(function (SocialMediaPlatform) {
    SocialMediaPlatform["facebook"] = "facebook";
    SocialMediaPlatform["instagram"] = "instagram";
})(SocialMediaPlatform = exports.SocialMediaPlatform || (exports.SocialMediaPlatform = {}));
var SocialMediaItemsType;
(function (SocialMediaItemsType) {
    SocialMediaItemsType["posts"] = "posts";
    SocialMediaItemsType["stories"] = "stories";
})(SocialMediaItemsType = exports.SocialMediaItemsType || (exports.SocialMediaItemsType = {}));
var SocialMediaItemType;
(function (SocialMediaItemType) {
    SocialMediaItemType["image"] = "image";
    SocialMediaItemType["video"] = "video";
})(SocialMediaItemType = exports.SocialMediaItemType || (exports.SocialMediaItemType = {}));
var SocialMediaWidgetOrientation;
(function (SocialMediaWidgetOrientation) {
    SocialMediaWidgetOrientation["vertical"] = "vertical";
    SocialMediaWidgetOrientation["horizontal"] = "horizontal";
    SocialMediaWidgetOrientation["square"] = "square";
})(SocialMediaWidgetOrientation = exports.SocialMediaWidgetOrientation || (exports.SocialMediaWidgetOrientation = {}));
var SocialMediaSelectionType;
(function (SocialMediaSelectionType) {
    SocialMediaSelectionType["latest"] = "latest";
    SocialMediaSelectionType["custom"] = "custom";
})(SocialMediaSelectionType = exports.SocialMediaSelectionType || (exports.SocialMediaSelectionType = {}));
var SocialMediaResponseFormat;
(function (SocialMediaResponseFormat) {
    SocialMediaResponseFormat["ui"] = "ui";
    // in player response, instagram carousel is flattened to separate social media posts
    SocialMediaResponseFormat["player"] = "player";
})(SocialMediaResponseFormat = exports.SocialMediaResponseFormat || (exports.SocialMediaResponseFormat = {}));
exports.isFabricSocialMediaOptions = (item) => (item === null || item === void 0 ? void 0 : item.type) === objects_1.ObjectType.CustomSocialMedia;
exports.isFacebookPage = (item) => !(item === null || item === void 0 ? void 0 : item.username);
exports.isInstagramAccount = (item) => item === null || item === void 0 ? void 0 : item.username;
exports.isSocialMediaVideoItem = (item) => item.mediaType === SocialMediaItemType.video;
exports.isSocialMediaImageItem = (item) => item.mediaType === SocialMediaItemType.image;
//# sourceMappingURL=socialMedia.js.map